function createMagmaInterpolator(t, opacity) {
  // Clamp t between 0 and 1
  t = Math.max(0, Math.min(1, t));

  // If t maps to lower half: Purple -> Red/Orange
  if (t < 0.5) {
    const localT = t * 2; // Map 0-0.5 to 0-1
    const startColor = [68, 1, 84]; // Deep purple #440154
    const midColor = [221, 95, 27]; // Red/Orange

    const r = Math.round(startColor[0] + (midColor[0] - startColor[0]) * localT);
    const g = Math.round(startColor[1] + (midColor[1] - startColor[1]) * localT);
    const b = Math.round(startColor[2] + (midColor[2] - startColor[2]) * localT);

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  } else {
    // If t maps to upper half: Red/Orange -> Bright Yellow/White
    const localT = (t - 0.5) * 2; // Map 0.5-1 to 0-1
    const startColor = [221, 95, 27]; // Red/Orange
    const endColor = [253, 231, 36]; // Bright yellow #fde724

    const r = Math.round(startColor[0] + (endColor[0] - startColor[0]) * localT);
    const g = Math.round(startColor[1] + (endColor[1] - startColor[1]) * localT);
    const b = Math.round(startColor[2] + (endColor[2] - startColor[2]) * localT);

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }
};

export default function generateHeatmapColor(value, minValue, maxValue, opacity) {
  const normalizedValue = (value - minValue) / (maxValue - minValue);
  const color = createMagmaInterpolator(normalizedValue, opacity);
  return color;
}


